import { Meta, StoryObj } from '@storybook/react';

import { Curtain } from './Curtain';

const meta: Meta<typeof Curtain> = {
  title: 'parts/loading/Curtain',
  component: Curtain,
  args: {},
};

export default meta;

type Story = StoryObj<typeof Curtain>;

export const Basic: Story = {
  render: args => <Curtain {...args} />,
};
